/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaWebSecuredConfiguration } from '../shiva-web-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { assignAgentToPartnerOperator } from '../fn/partners-operator/assign-agent-to-partner-operator';
import { AssignAgentToPartnerOperator$Params } from '../fn/partners-operator/assign-agent-to-partner-operator';
import { assignStationToPartnerOperator } from '../fn/partners-operator/assign-station-to-partner-operator';
import { AssignStationToPartnerOperator$Params } from '../fn/partners-operator/assign-station-to-partner-operator';
import { createPartnerOperator } from '../fn/partners-operator/create-partner-operator';
import { CreatePartnerOperator$Params } from '../fn/partners-operator/create-partner-operator';
import { deletePartnerOperator } from '../fn/partners-operator/delete-partner-operator';
import { DeletePartnerOperator$Params } from '../fn/partners-operator/delete-partner-operator';
import { getPartnerOperator } from '../fn/partners-operator/get-partner-operator';
import { GetPartnerOperator$Params } from '../fn/partners-operator/get-partner-operator';
import { PartnerOperator } from '../models/partner-operator';
import { PartnerOperatorPagedList } from '../models/partner-operator-paged-list';
import { searchPartnerOperatorList } from '../fn/partners-operator/search-partner-operator-list';
import { searchPartnerOperatorList$Any } from '../fn/partners-operator/search-partner-operator-list-any';
import { SearchPartnerOperatorList$Any$Params } from '../fn/partners-operator/search-partner-operator-list-any';
import { SearchPartnerOperatorList$Params } from '../fn/partners-operator/search-partner-operator-list';
import { subscribePartnersOperator } from '../fn/partners-operator/subscribe-partners-operator';
import { SubscribePartnersOperator$Params } from '../fn/partners-operator/subscribe-partners-operator';
import { updatePartnerOperator } from '../fn/partners-operator/update-partner-operator';
import { UpdatePartnerOperator$Params } from '../fn/partners-operator/update-partner-operator';


/**
 * All about the partners operator
 */
@Injectable({ providedIn: 'root' })
export class PartnersOperatorService extends BaseService {
  constructor(config: ShivaWebSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createPartnerOperator()` */
  static readonly CreatePartnerOperatorPath = '/partners/operator';

  /**
   * Create a partner operator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPartnerOperator()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPartnerOperator$Response(params: CreatePartnerOperator$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createPartnerOperator(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a partner operator.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createPartnerOperator$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createPartnerOperator(params: CreatePartnerOperator$Params, context?: HttpContext): Observable<void> {
    return this.createPartnerOperator$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getPartnerOperator()` */
  static readonly GetPartnerOperatorPath = '/partners/operator/{uid}';

  /**
   * Get a partner operator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPartnerOperator()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerOperator$Response(params: GetPartnerOperator$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerOperator>> {
    return getPartnerOperator(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a partner operator.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPartnerOperator$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPartnerOperator(params: GetPartnerOperator$Params, context?: HttpContext): Observable<PartnerOperator> {
    return this.getPartnerOperator$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartnerOperator>): PartnerOperator => r.body)
    );
  }

  /** Path part for operation `updatePartnerOperator()` */
  static readonly UpdatePartnerOperatorPath = '/partners/operator/{uid}';

  /**
   * Update a partner operator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updatePartnerOperator()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePartnerOperator$Response(params: UpdatePartnerOperator$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updatePartnerOperator(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a partner operator.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updatePartnerOperator$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updatePartnerOperator(params: UpdatePartnerOperator$Params, context?: HttpContext): Observable<void> {
    return this.updatePartnerOperator$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deletePartnerOperator()` */
  static readonly DeletePartnerOperatorPath = '/partners/operator/{uid}';

  /**
   * Delete a parnter operator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePartnerOperator()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePartnerOperator$Response(params: DeletePartnerOperator$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deletePartnerOperator(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a parnter operator.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deletePartnerOperator$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deletePartnerOperator(params: DeletePartnerOperator$Params, context?: HttpContext): Observable<void> {
    return this.deletePartnerOperator$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `assignAgentToPartnerOperator()` */
  static readonly AssignAgentToPartnerOperatorPath = '/partners/operator/{uid}/agent/{agentUid}/assign';

  /**
   * Assign agent to a partner operator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignAgentToPartnerOperator()` instead.
   *
   * This method doesn't expect any request body.
   */
  assignAgentToPartnerOperator$Response(params: AssignAgentToPartnerOperator$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return assignAgentToPartnerOperator(this.http, this.rootUrl, params, context);
  }

  /**
   * Assign agent to a partner operator.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignAgentToPartnerOperator$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assignAgentToPartnerOperator(params: AssignAgentToPartnerOperator$Params, context?: HttpContext): Observable<void> {
    return this.assignAgentToPartnerOperator$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `subscribePartnersOperator()` */
  static readonly SubscribePartnersOperatorPath = '/partners/operator/{countryCode}/{partyId}/subscribe/{subscriptionUid}';

  /**
   * Subscribe partner operator credentials role to plan.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `subscribePartnersOperator()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribePartnersOperator$Response(params: SubscribePartnersOperator$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return subscribePartnersOperator(this.http, this.rootUrl, params, context);
  }

  /**
   * Subscribe partner operator credentials role to plan.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `subscribePartnersOperator$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  subscribePartnersOperator(params: SubscribePartnersOperator$Params, context?: HttpContext): Observable<void> {
    return this.subscribePartnersOperator$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `assignStationToPartnerOperator()` */
  static readonly AssignStationToPartnerOperatorPath = '/partners/operator/{countryCode}/{partyId}/station/{stationUid}/assign';

  /**
   * Assign station to a partner operator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignStationToPartnerOperator()` instead.
   *
   * This method doesn't expect any request body.
   */
  assignStationToPartnerOperator$Response(params: AssignStationToPartnerOperator$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return assignStationToPartnerOperator(this.http, this.rootUrl, params, context);
  }

  /**
   * Assign station to a partner operator.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignStationToPartnerOperator$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  assignStationToPartnerOperator(params: AssignStationToPartnerOperator$Params, context?: HttpContext): Observable<void> {
    return this.assignStationToPartnerOperator$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `searchPartnerOperatorList()` */
  static readonly SearchPartnerOperatorListPath = '/partners/operator/search';

  /**
   * Search partners operator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchPartnerOperatorList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchPartnerOperatorList$Response(params?: SearchPartnerOperatorList$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerOperatorPagedList>> {
    return searchPartnerOperatorList(this.http, this.rootUrl, params, context);
  }

  /**
   * Search partners operator.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchPartnerOperatorList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchPartnerOperatorList(params?: SearchPartnerOperatorList$Params, context?: HttpContext): Observable<PartnerOperatorPagedList> {
    return this.searchPartnerOperatorList$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartnerOperatorPagedList>): PartnerOperatorPagedList => r.body)
    );
  }

  /**
   * Search partners operator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchPartnerOperatorList$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchPartnerOperatorList$Any$Response(params?: SearchPartnerOperatorList$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<PartnerOperatorPagedList>> {
    return searchPartnerOperatorList$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search partners operator.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchPartnerOperatorList$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchPartnerOperatorList$Any(params?: SearchPartnerOperatorList$Any$Params, context?: HttpContext): Observable<PartnerOperatorPagedList> {
    return this.searchPartnerOperatorList$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<PartnerOperatorPagedList>): PartnerOperatorPagedList => r.body)
    );
  }

}
